import React from 'react';
import {Flex, Arrow} from '/app/src/component';
import _ from 'lodash';


const WrapperStyle = {
    fontSize: '14px',
    color: 'Black_M',
    margin: '5px 0px',
    vAlignContent: 'center'
}

const TagStyle = {
    backgroundColor: 'LightGray1',
    borderRadius: '60px',
    center: true,
    padding: '0px 10px',
    height: '30px',
    cursor : 'default',

}

export default ({entry, ...rest }) => {
    const exchange = _.get(entry, ['meta', 'details', 'exchange'])
    if(!exchange)
        return null

    return (
        <Flex {...WrapperStyle}>
            {exchange.parent_label && (
            <React.Fragment>
                <Flex {...TagStyle} >
                    {exchange.parent_label}
                </Flex>
                <Arrow direction='right' h='20px' w='20px' size='small'/>
            </React.Fragment>
            )}
            <Flex  {...TagStyle}>
                {exchange.label}
            </Flex>
        </Flex>
    )
}



// WEBPACK FOOTER //
// ./src/component/Conversation/Message/_ExchangeData.js